import lang from '../../../../lib/language';

import NoResultsFound from '../../../../components/NoResultsFound/NoResultsFound';
import useIsMobile from '../../../hooks/useIsMobile';

import styles from './LatestNewsContent.module.scss';

type Props = {
  newsCards: JSX.Element[];
  isLoggedIn: boolean;
  isNewsAvailable: boolean;
  isLoading: boolean;
  selectedSymbol?: string;
};

const LatestNewsContent = (
  {
    selectedSymbol,
    isLoggedIn,
    newsCards,
    isNewsAvailable,
    isLoading,
  }: Props,
): JSX.Element => {
  const { isMobile } = useIsMobile();

  let wrapperClass;
  if (isMobile) {
    wrapperClass = selectedSymbol
      ? styles.wrapperLatestNewsMobileSymbol
      : styles.wrapperLatestNewsMobile;
  } else {
    wrapperClass = styles.wrapperLatestNews;
  }

  if (isLoading) {
    return (
      <div className={wrapperClass}>
        {newsCards}
      </div>
    );
  }

  if (!isNewsAvailable) {
    return <NoResultsFound fullText={lang.newsNotFoundMessage()} />;
  }

  return (
    <div className={wrapperClass}>
      {newsCards}
    </div>
  );
};

export default LatestNewsContent;
